import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * Properties for {@link GroupRedirect}
 */
type GroupRedirectProps = {};

/**
 * Redirect page for groups
 */
function GroupRedirect(props: GroupRedirectProps) {
    return <Navigate to={"/a/groups/local"} search={{ search: "", page: 1 }} />;
}

export const Route = createFileRoute("/_admin/a/groups/")({
    component: GroupRedirect,
});
